export default __webpack_public_path__ + "designer_block_jason-4eX.jpg";